export default __webpack_public_path__ + "static/blog_modal_bg-aace3770822cd11d6bfa1222016583be.png";